import React, { useEffect } from "react";
import styles from "./MyBills.module.css";

import PageLayout from "../../components/PageLayout/PageLayout";
import BillList from "../../components/MainContent/Body/BillList/BillList";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../app/store";
import { getMyBills } from "../../slices/bill/billSlice";

const MyBills: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const bills = useSelector((state: RootState) => state.bills.bills);

  useEffect(() => {
    dispatch(getMyBills());
  }, [dispatch]);

  return (
    <PageLayout className={styles.MyBills}>
      <h1 className={styles.Title}>Moje rachunki</h1>

      <div className={styles.InfoBox}>
        <div className={styles.InfoTitle}>Płatności za usługi CARTENA</div>

        <div className={styles.InfoText}>
          Tutaj znajdziesz wszystkie rachunki związane z dodaniem firmy,
          wyróżnieniem, poleceniem oraz przedłużeniem publikacji wizytówki.
        </div>
      </div>

      <BillList bills={bills} />
    </PageLayout>
  );
};

export default MyBills;